import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { AuthLayout } from '../components/AuthLayout'
import { Button } from '../components/Button'
import { Field } from '../components/Field'
import { getSupabase } from '../lib/supabase'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [sent, setSent] = useState(false)

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    setSubmitting(true)
    setError(null)

    const { error: resetError } = await getSupabase().auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/`,
    })

    if (resetError) {
      setError(resetError.message)
      setSubmitting(false)
      return
    }

    setSent(true)
    setSubmitting(false)
  }

  return (
    <AuthLayout
      title={sent ? 'Check your inbox' : 'Reset your password'}
      subtitle={
        sent
          ? `If an account exists for ${email.trim()}, we sent a password reset link.`
          : 'Enter your account email and we’ll send you a reset link.'
      }
      footer={
        <p>
          Remembered it?{' '}
          <Link to="/login" className="font-medium text-cobalt underline-offset-4 hover:underline">
            Back to sign in
          </Link>
        </p>
      }
    >
      {!sent && (
        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <Field
            label="Email"
            type="email"
            name="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            error={error}
          />
          <Button type="submit" size="lg" fullWidth loading={submitting}>
            Send reset link
          </Button>
        </form>
      )}

      {sent && (
        <Button type="button" variant="secondary" size="lg" fullWidth onClick={() => setSent(false)}>
          Use a different email
        </Button>
      )}
    </AuthLayout>
  )
}
